import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';



function AddOrcamento() {
  const navigate = useNavigate();

  const [opcoesFuncionais, setOpcoesFuncionais] = useState([]);
  const[classificacaoinstitucional, setClassificacaoinstitucional] = useState([])
  const [aplicacao,setAplicacao]= useState([])
  const[contaelemento,setContaElemento]=useState([])
  const[unidade,setUnidade] = useState([])
  const[fonteRecurso, setFonteRecurso] = useState([])
  useEffect(() => {
  fetch('/api/funcionais')
    .then(res => res.json())
    .then(data => setOpcoesFuncionais(data))
    .catch(err => console.error('Erro ao carregar funcionais:', err));

  fetch('/api/classificacao')
    .then(res => res.json())
    .then(data => setClassificacaoinstitucional(data))
    .catch(err => console.error('Erro ao carregar classificação:', err));

    fetch('/api/aplicacao')
    .then(res => res.json())
    .then(data => setAplicacao(data))
    .catch(err => console.error('Erro ao carregar aplicação:', err));

    fetch('/api/contaelemento')
    .then(res => res.json())
    .then(data => setContaElemento(data))
    .catch(err => console.error('Erro ao carregar Conta elemento:', err));

    fetch('/api/unidade')
    .then(res => res.json())
    .then(data => setUnidade(data))
    .catch(err => console.error('Erro ao carregar Conta elemento:', err));

    fetch('/api/fontederecurso')
    .then(res => res.json())
    .then(data => setFonteRecurso(data))
    .catch(err => console.error('Erro ao carregar Conta elemento:', err));

}, []);

  const [form, setForm] = useState({
    valor: '', 
    unidade: '', 
    orcamento: '',  
    funcional_programatica: '', 
    fonte_recurso_stn: '', 
    fonte_recurso: '', 
    ficha: '', 
    conta_elemento_despesa: '', 
    classificacao_institucional: '', 
    aplicacao: '', 
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .post('/api/orcamento', form)
      .then((res) => {
        if (res.data.Status === 'Success') {
          alert('Orcamento criado com sucesso!');
          navigate('/orcamento');
        } else {
          alert('Erro ao criar ORÇAMENTO');
        }
      })
      .catch((err) => {
        console.error(err);
        alert('Erro no servidor');
      });
  };

  return (
  <div className="px-4 py-3">
    <h3 className="mb-4">Adicionar Novo Lançamento Orçamentário</h3>
    <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <label>Valor</label>
        <input
          type="number"
          step="0.01"
          name="valor"
          className="form-control"
          required
          value={form.valor}
          onChange={handleChange}
        />
      </div>

      <div className="mb-3">
        <label>Unidade</label>
        <select
          name="unidade"
          className="form-control"
          required
          value={form.unidade}
          onChange={handleChange}
        >
         <option value="">Selecione...</option>
        {unidade.map((op,index) => (
      <option key={index} value={op.unidade}>
            {op.unidade}
          </option>
        ))}
        </select>
      </div>

      <div className="mb-3">
        <label>Orçamento</label>
        <select
          type="text"
          name="orcamento"
          className="form-control"
          required
          placeholder="Ex.: 04.122.1008.2476"
          value={form.orcamento}
          onChange={handleChange}
        >
            <option value="Sim">Sim</option>
            <option value="Nao">Não</option>
        </select>
      </div>

     <div className="mb-3">
  <label>Funcional Programática</label>
  <select
    name="funcional_programatica"
    className="form-control"
    required
    value={form.funcional_programatica}
    onChange={handleChange}
  >
    <option value="">Selecione...</option>
    {opcoesFuncionais.map((op,index) => (
      <option key={index} value={op.funcional_programatica}>
            {op.funcional_programatica}
          </option>
    ))}
  </select>
</div>


      <div className="mb-3">
        <label>Fonte de Recurso STN</label>
        <select
          type="text"
          name="fonte_recurso_stn"
          className="form-control"
          required
          placeholder="Ex.: 01 - Tesouro"
          value={form.fonte_recurso_stn}
          onChange={handleChange}
        >
          <option value="">Selecione...</option>
    {fonteRecurso.map((op,index) => (
      <option key={index} value={op.fonte_recurso_stn}>
            {op.fonte_recurso_stn}
          </option>
    ))}
   
    </select>
      </div>

      <div className="mb-3">
        <label>Fonte de Recurso</label>
        <select
          name="fonte_recurso"
          className="form-control"
          required
          placeholder="Ex.: 1500 - Recursos Não Vinculados"
          value={form.fonte_recurso}
          onChange={handleChange}
        >

        <option value="">Selecione...</option>
        <option value="01">01 - Tesouro</option>
        <option value="02">02 - Transferência e Convênios Estaduais - Vinculados </option>
        <option value="05">05 - Transferência e Convênios Federais - Vinculados</option>
        <option value="07">07 - Operações de Crédito</option>
        <option value="91">91 - Tesouro - Exercícios Anteriores</option>
        <option value="95">95 - Transferência e Convênios Federais - Vinculados - Exercícios Anteriores</option>
        </select>
      </div>

      <div className="mb-3">
        <label>Ficha</label>
        <input
          type="text"
          name="ficha"
          className="form-control"
          required
          placeholder=""
          value={form.ficha}
          onChange={handleChange}
        />
      </div>

      <div className="mb-3">
        <label>Conta / Elemento de Despesa</label>
        <select
          
          name="conta_elemento_despesa"
          className="form-control"
          required
          placeholder="Ex.: 3.1.90.11.00"
          value={form.conta_elemento_despesa}
          onChange={handleChange}
        >
        <option value="">Selecione...</option>
    {contaelemento.map((op, index) => (
      <option key={index} value={op.conta_elemento_despesa}>
        {op.conta_elemento_despesa}
      </option>
    ))}
        </select>

        
      </div>

     <div className="mb-3">
  <label>Classificação Institucional</label>
  <select
    name="classificacao_institucional"
    className="form-control"
    required
    value={form.classificacao_institucional}
    onChange={handleChange}
  >
    <option value="">Selecione...</option>
    {classificacaoinstitucional.map((op, index) => (
      <option key={index} value={op.classificacao_institucional}>
        {op.classificacao_institucional}
      </option>
    ))}
  </select>
</div>


      <div className="mb-3">
        <label>Aplicação</label>
        <select
          type="text"
          name="aplicacao"
          className="form-control"
          required
          value={form.aplicacao}
          onChange={handleChange}
        >
          <option value="">Selecione...</option>
          {aplicacao.map((op, index) => (
         <option key={index} value={op.aplicacao}>
          {op.aplicacao}
         </option>
        ))}
        </select>
      </div>

      <button type="submit" className="btn btn-primary">
        Salvar Lançamento
      </button>
    </form>
  </div>
);




}
export default AddOrcamento;